import React from "react";
import '../css/form-modal.css'

const FormModal = ({ onClose }) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;

        fetch(form.action, {
            method: form.method,
            body: new FormData(form),
        })
            .then((response) => {
                if (response.ok) {
                    window.location.href = "/thanks";
                } else {
                    alert("There was an issue submitting the form. Please try again.");
                }
            })
            .catch((error) => {
                console.error("Form submission error:", error);
                alert("An error occurred while submitting the form.");
            });
    };
    return (
        <div className="form-modal-section swipe">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">MP Holidays Pvt. Ltd.</h4>
                        <h5 className="modal-title">Share Your Query with Us!!</h5>
                        <span className="close" onClick={onClose}>
                            <i className="fa-solid fa-circle-xmark"></i>
                        </span>
                    </div>
                    <div className="discount">
                        <h4>Get Up to</h4>
                        <span><span>50%</span> off</span>
                        <h4>on all bookings</h4>
                    </div>
                    <br />
                    <div className="modal-body">
                        <form action="https://api.web3forms.com/submit" method="POST" onSubmit={handleSubmit}>
                            <input
                                type="hidden"
                                name="subject"
                                value="Query MP Holidays Pvt Ltd."
                            />
                            <input
                                type="hidden"
                                name="from_name"
                                value="MP Holidays Pvt Ltd."
                            />
                            <input
                                type="hidden"
                                name="access_key"
                                value="43e459d4-2303-43a5-827a-74423261a455"
                            ></input>
                            <div className="contact-form-container">
                                <div className="contact-form-left">
                                    <div className="form-group">
                                        <label htmlFor="name">Name:</label>
                                        <input type="text" className="form-control" id="name" name="name" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Email:</label>
                                        <input type="email" className="form-control" id="email" name="email" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone:</label>
                                        <input type="tel" pattern="[0-9]{10}" className="form-control" id="phone" name="phone" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="comingFrom">Coming From:</label>
                                        <input type="text" className="form-control" id="comingFrom" name="comingFrom" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="adults">No of Adults:</label>
                                        <input type="number" className="form-control" id="adults" name="adults" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="children">No of Children:</label>
                                        <input type="number" className="form-control" id="children" name="children" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="days">No of Days:</label>
                                        <input type="number" className="form-control" id="days" name="days" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="travelDate">Preferred Travel Date:</label>
                                        <input type="date" className="form-control" id="travelDate" name="travel_date" required />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="message">Message:</label>
                                        <textarea className="form-control" id="message" name="message" placeholder="Type your message..." required></textarea>
                                    </div>
                                </div>
                                <div className="contact-form-right">
                                    <div className="form-group">
                                        <label>Car Required:</label>
                                        <div className="form-radio">
                                            <span>
                                                <input type="radio" className="form-check-input" id="carYes" name="carRequired" value="Yes" />
                                                <label className="form-check-label" htmlFor="carYes">Yes</label>
                                            </span>
                                            <span>
                                                <input type="radio" className="form-check-input" id="carNo" name="carRequired" value="No" />
                                                <label className="form-check-label" htmlFor="carNo">No</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Flight Required:</label>
                                        <div className="form-radio">
                                            <span>
                                                <input type="radio" className="form-check-input" id="flightYes" name="flightRequired" value="Yes" />
                                                <label className="form-check-label" htmlFor="flightYes">Yes</label>
                                            </span>
                                            <span>
                                                <input type="radio" className="form-check-input" id="flightNo" name="flightRequired" value="No" />
                                                <label className="form-check-label" htmlFor="flightNo">No</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Hotel Category:</label>
                                        <div className="form-radio">
                                            <span>
                                                <input type="radio" className="form-check-input" id="hotel5" name="hotelCategory" value="5 Star" />
                                                <label className="form-check-label" htmlFor="hotel5">5 Star</label>
                                            </span>
                                            <span>
                                                <input type="radio" className="form-check-input" id="hotel4" name="hotelCategory" value="4 Star" />
                                                <label className="form-check-label" htmlFor="hotel4">4 Star</label>
                                            </span>
                                            <span>
                                                <input type="radio" className="form-check-input" id="hotel3" name="hotelCategory" value="3 Star" />
                                                <label className="form-check-label" htmlFor="hotel3">3 Star</label>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Meal Plan:</label>
                                        <div className="form-radio">
                                            <span>
                                                <input type="checkbox" className="form-check-input" id="breakfast" name="Breakfast" value="Yes" />
                                                <label className="form-check-label" htmlFor="breakfast">Breakfast</label>
                                            </span>
                                            <span>
                                                <input type="checkbox" className="form-check-input" id="lunch" name="Lunch" value="Yes" />
                                                <label className="form-check-label" htmlFor="lunch">Lunch</label>
                                            </span>
                                            <span>
                                                <input type="checkbox" className="form-check-input" id="dinner" name="Dinner" value="Yes" />
                                                <label className="form-check-label" htmlFor="dinner">Dinner</label>
                                            </span>
                                        </div>
                                    </div>
                                    <br />
                                    <label>Destinations to be Covered:</label>
                                    <br />
                                    <div className="destination-list">
                                        {["Ujjain", "Indore", "Omkareshwar", "Maheshwar", "Mandu", "Pachmarhi", "Kanha", "Bandhavgarh", "Pench", "Bhedaghat", "Amarkantak", "Khajuraho", "Panna", "Orchha", "Gwalior", "Chanderi", "Shivpuri", "Other"].map((place, index) => (
                                            <span key={index}>
                                                <input type="checkbox" className="form-check-input" id={`destination${index}`} name={`DestinationsToBeCovered${index+1}`} value={place} />
                                                <label className="form-check-label" htmlFor={`destination${index}`}>{place}</label>
                                            </span>
                                        ))}

                                    </div>
                                    <br />
                                    <label>Arrival Destination:</label>
                                    <br />
                                    <div className="destination-list">
                                        {["Bhopal", "Indore", "Jabalpur", "Pipariya", "Itarsi", "Nagpur", "Gwalior", "Umaria", "Katni", "Other"].map((place, index) => (
                                            <span key={index}>
                                                <input type="radio" className="form-check-input" id={`destination${index}`} name="arrival-destination" value={place} />
                                                <label className="form-check-label" htmlFor={`destination${index}`}>{place}</label>
                                            </span>
                                        ))}
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <button type="submit" className="submit-button" name="submit">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormModal;
// import React, { useEffect, useState } from 'react';

// const Formmodal = () => {
//   const [data, setData] = useState([]);
//   const [error, setError] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [counter, setCounter] = useState(0);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch('https://fakestoreapi.com/products/');
//         const result = await response.json(); // Parse JSON response
//         setData(result); // Set data in state
//         setLoading(false); // Set loading to false after data is fetched
//       } catch (error) {
//         setError(true);
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   return (
//     <div>
//       <p>Data</p>
//       {loading && <p>Loading...</p>}
//       {error && <p>Error fetching data.</p>}
//       {!loading && !error && (
//         data.map((elem, index) => (
//           <div key={index}>
//             <p>{elem.title}</p>
//             <img src={elem.image} alt="" />
//           </div>
//         ))
//       )}
//       <button onClick={() => setCounter(counter + 1)}>Count: {counter}</button>
//       <button onClick={() => setCounter(counter - 1)}>Count: {counter}</button>
//     </div>
//   );
// };

// export default Formmodal;
